<template>
    <div>
        <div class="page-header pr-0">
            <h2><a href="/dashboard"><i class="fas fa-tachometer-alt"></i></a></h2>
            <ol class="breadcrumbs">
                <li class="active"><span>Guías de remisión</span></li>
            </ol>
            <div class="right-wrapper pull-right">
                <a :href="`/${resource}/create`" class="btn btn-custom btn-sm  mt-2 mr-2"><i
                    class="fa fa-plus-circle"></i> Nuevo</a>
                <a href="#" @click.prevent="showModalGenerateCPE = true" class="btn btn-custom btn-sm  mt-2 mr-2">Generar
                    comprobante desde múltiples guías</a>
            </div>
        </div>
        <div class="card mb-0">
            <div class="card-body">
                <data-table :resource="resource">
                    <tr slot="heading">
                        <th>#</th>
                        <th class="text-center">Fecha Emisión</th>
                        <th>Cliente</th>
                        <th>Número</th>
                        <th>Estado</th>
                        <th class="text-center">Fecha Envío</th>
                        <th class="text-center">N° Comprobante</th>

                        <th class="text-center">Tipo Dispositivo</th>

                        <th class="text-center">Descargas</th>
                        <th class="text-center">Acciones</th>
                        <th class="text-center"></th>
                    <tr>
                    <tr slot-scope="{ index, row }" :class="{'text-danger': (row.state_type_id === '11')}">
                        <td>{{ index }}</td>
                        <td class="text-center">{{ row.date_of_issue }}</td>
                        <td>{{ row.customer_name }} <br/> <small>{{ row.customer_number }}</small></td>
                        <td>{{ row.number }}</td>
                        <td>
                            <template v-if="isAuditor">
                                <el-popover
                                    placement="top"
                                    trigger="click"
                                >

                                    <div
                                        style="display: flex; flex-direction: column; gap: 5px;"
                                    >
                                        <div v-for="sate in stateTypes"
                                            v-if="sate.id !== row.state_type_id"
                                            :key="sate.id"
                                            class="badge bg-secondary text-white"
                                            style="display: block; cursor: pointer;"
                                            :class="{'bg-danger': (sate.id === '11'),
                                                    'bg-warning': (sate.id === '13'),
                                                    'bg-secondary': (sate.id === '01'),
                                                    'bg-info': (sate.id === '03'),
                                                    'bg-success': (sate.id === '05'),
                                                    'bg-secondary': (sate.id === '07'),
                                                    'bg-dark': (sate.id === '09')}"
                                            @click="changeStateSunat(row, sate.id)"
                                        >{{ sate.description }}</div>
                                    </div>

                                    <span slot="reference" style="cursor: pointer;"
                                        class="badge bg-secondary text-white"
                                        :class="{'bg-secondary': (row.state_type_id === '01'),
                                            'bg-info': (row.state_type_id === '03'),
                                            'bg-success': (row.state_type_id === '05'),
                                            'bg-secondary': (row.state_type_id === '07'),
                                            'bg-dark': (row.state_type_id === '09'),
                                            'bg-danger': (row.state_type_id === '11')}"
                                    >
                                        {{ row.state_type_description }}
                                    </span>
                                </el-popover>
                            </template>

                            <span v-else class="badge bg-secondary text-white"
                                :class="{'bg-secondary': (row.state_type_id === '01'),
                                'bg-info': (row.state_type_id === '03'),
                                'bg-success': (row.state_type_id === '05'),
                                'bg-secondary': (row.state_type_id === '07'),
                                'bg-dark': (row.state_type_id === '09'),
                                'bg-danger': (row.state_type_id === '11')
                                }"
                            >
                                {{ row.state_type_description }}
                            </span>
                        </td>
                        <td class="text-center">{{ row.date_of_shipping }}</td>

                        <td class="text-center">
                            <template v-for="(row,index) in row.documents">
                                <label class="d-block" :key="index">{{ row.description }}</label>
                            </template>
                        </td>

                        <td class="text-center">{{ row.type_device }}</td>

                        <td class="text-center">
                            <button type="button" class="btn waves-effect waves-light btn-xs btn-info"
                                    @click.prevent="clickDownload(row.download_external_xml)">XML
                            </button>
                            <button type="button" class="btn waves-effect waves-light btn-xs btn-info"
                                    @click.prevent="clickDownload(row.external_id, true)" v-if="row.btn_pdf">PDF
                            </button>
                            <button type="button" class="btn waves-effect waves-light btn-xs btn-info"
                                    @click.prevent="clickDownload(row.download_external_cdr)" v-if="row.has_cdr">CDR
                            </button>
                        </td>
                        <td class="text-center">
                            <button type="button" class="btn waves-effect waves-light btn-xs btn-info"
                                    @click.prevent="onGenerateDocument(row.id)" v-if="row.btn_generate_document">Generar comprobante
                            </button>
                            <button type="button" class="btn waves-effect waves-light btn-xs btn-info"
                                    @click.prevent="btnStatusTicket(row.external_id, row.soap_send_id)" v-if="row.btn_status_ticket">Consultar ticket
                            </button>
                            <button type="button" class="btn waves-effect waves-light btn-xs btn-info"
                                    @click.prevent="clickOptions(row.id)" v-if="row.btn_options">Opciones
                            </button>
                            <button type="button" class="btn waves-effect waves-light btn-xs btn-info"
                                    @click.prevent="sendSunat(row.external_id)" v-if="row.btn_send">Enviar a Sunat
                            </button>
                            <a :href="`/dispatches/create_new/dispatch/${row.id}`"
                               class="btn waves-effect waves-light btn-xs btn-warning m-1__2" v-if="row.btn_edit">Editar</a>
                        </td>

                        <td>
                            <template>
                                <div class="dropdown">
                                    <button id="dropdownMenuButton"
                                            aria-expanded="false"
                                            aria-haspopup="true"
                                            class="btn btn-default btn-sm"
                                            data-toggle="dropdown"
                                            type="button">
                                        <i class="fas fa-ellipsis-v"></i>
                                    </button>
                                    <div aria-labelledby="dropdownMenuButton"
                                        class="dropdown-menu">

                                        <button v-if="row.soap_shipping_response"
                                            class="dropdown-item"
                                            @click="clickViewShippingResponse(row.soap_shipping_response, row.number)"
                                        >
                                            Ver observaciones de validación
                                        </button>

                                        <button v-if="row.state_type_id === '05' && configuration.show_voided_dispatch_button"
                                            class="dropdown-item"
                                            @click.prevent="voidDispatch(row.id)"
                                            style="background-color: #ED1C24; color: #fff;"
                                        >
                                            Cambiar a Anulado
                                        </button>
                                        
                                    </div>
                                </div>
                            </template>
                        </td>
                    </tr>
                </data-table>
            </div>
        </div>
        <dispatch-options :showDialog.sync="showDialogOptions"
                          :recordId="recordId"
                          :showClose="true"></dispatch-options>

        <FormGenerateDocument
            :showDialog.sync="showDialogGenerateDocument"
            :recordId="recordId"
            :showClose="true"
            :showGenerate="true"
            :configuration="configuration"
        ></FormGenerateDocument>
        <ModalGenerateCPE :show.sync="showModalGenerateCPE"></ModalGenerateCPE>
    </div>
</template>

<script>
import DataTable from '../../../components/DataTableDispatch.vue'
// import DataTable from '../../../components/DataTable.vue'
import DispatchOptions from './partials/options.vue'
import FormGenerateDocument from "./generate-document";
import ModalGenerateCPE from './ModalGenerateCPE';

export default {
    components: {DataTable, DispatchOptions, FormGenerateDocument, ModalGenerateCPE},
    props: ['configuration', 'isAuditor', 'stateTypes'],
    data() {
        return {
            resource: 'dispatches',
            showDialogOptions: false,
            recordId: null,
            showDialogGenerateDocument: false,
            showModalGenerateCPE: false,
        }
    },
    created() {
        this.$setStorage('configuration', this.configuration)
    },
    methods: {
        showSentSunat(row) {
            let data = row.soap_shipping_response;
            if (this.configuration.auto_send_dispatchs_to_sunat === true) return false;
            if (data === undefined || data === null) return true;
            if (data.sent === null || data.sent === false) return true;
            return false;
        },
        async sendSunat(external_id) {
            await this.$http.get(`/service/dispatch/send/${external_id}`)
                .then(response => {
                    // console.log(response.data);
                    let data = response.data;
                    if(data.success) {
                        this.$notify.success({
                            title: 'Se ha realizado el envio',
                            message: data.message,
                        });
                    } else {
                        this.$notify.error({
                            title: 'Envio no realizado',
                            message: data.message,
                        });
                    }
                }).then(() => {
                    //this.loading_sunat_send = false;
                });
            this.$eventHub.$emit('reloadData')

            // this.$http.post(`/dispatches/sendSunat/${id}`)
            //     .then((result) => {
            //         let data = result.data;
            //         if (data.sent === false) {
            //             this.$notify.error({
            //                 title: 'Envio no realizado',
            //                 message: data.description,
            //             });
            //         } else {
            //             this.$notify.success({
            //                 title: 'Se ha realizado el envio',
            //                 message: data.description,
            //             });
            //         }
            //     }).catch(() => {
            //     this.$notify.success({
            //         title: 'Error',
            //         message: 'Error desconocido',
            //     });
            // })
        },
        onGenerateDocument(dispatchId) {
            this.recordId = dispatchId;
            this.showDialogGenerateDocument = true;
        },
        clickOptions(recordId = null) {
            this.recordId = recordId
            this.showDialogOptions = true
        },
        clickDownload(download, pdf = false) {
            if (pdf) {
                if (download) {
                    window.open(`/print_download/dispatch/${download}/a4`, '_blank')
                } else {
                    this.$message.error('El pdf no esta disponible por el momento')
                }
            } else {
                window.open(download, '_blank');
            }
        },
        clickPrint(external_id) {
            window.open(`/print/dispatch/${external_id}/a4`, '_blank');
        },
        btnStatusTicket(external_id, soap_send_id) {
            this.$http.post(`/dispatches/status_ticket`, {
                'external_id': external_id,
                'soap_send_id': soap_send_id
            })
                .then((result) => {
                    let data = result.data;
                    if (data.success) {
                        this.$message.success(data.message)
                    } else {
                        this.$message.error(data.message)
                    }
                    this.$eventHub.$emit('reloadData')
                }).catch(() => {
                this.$notify.success({
                    title: 'Error',
                    message: 'Error desconocido',
                });
            })
        },

        voidDispatch(id) {
            this.$confirm('<span class="text-danger">Importante: En el sistema puede cambiar el estado a anulado su guia de remisión, pero no esta anulando la guia de remisión solo visualmente en el sistema, para anular una guia de remisión se tiene que hacer desde la Clave Sol, video de ejemplo:</span><br> <a target="_blank" class="text-danger" href="https://youtu.be/nxCXThL8gLs">https://youtu.be/nxCXThL8gLs</a>', 'Anular guia de remisión', {
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {

                this.$http.post(`/dispatches/change_to_voided`, {
                    id
                })
                .then((result) => {
                    let data = result.data;
                    if (data.success) {
                        this.$message.success(data.message)
                    } else {
                        this.$message.error(data.message)
                    }
                    this.$eventHub.$emit('reloadData')
                }).catch(() => {
                    this.$notify.success({
                        title: 'Error',
                        message: 'Error desconocido',
                    });
                })

            }).catch(() => {

            })

            
        },

        clickViewShippingResponse(soap_shipping_response, number) {

            const response_array = soap_shipping_response.notes
            let message = ''
            response_array.forEach(element => {
                message += '📌' + element + '<br>'
            })

            message = message.length <= 0 ? 'No hay observaciones de validación' : message

            this.$alert('<span class="">'+message+'</span>', `${number} Observaciones de validación`,{
                dangerouslyUseHTMLString: true
            })
            .catch(() => {})
            
        },

        async changeStateSunat(row, new_state) {
            const response = await this.$http.post(`/dispatches/change_state_sunat/${row.id}`, {
                    new_state_type_id: new_state
                })
            if (response.data.success) {
                this.$message.success(response.data.message)
                this.$eventHub.$emit('reloadData')
            } else {
                this.$message.error(response.data.message)
            }
        }

    }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/tenant/dispatches/index.vue